<template>
  <v-app v-if="currentUser">
    <v-navigation-drawer app permanent mini-variant expand-on-hover>
      <template #prepend>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>FNG-Siegel</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item color="secondary" v-if="currentUser.state === 'APPROVED'" link :to="{ name: 'home' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-text-box-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.user.audit") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          color="secondary"
          v-if="currentUser.state === 'APPROVED'"
          link
          :to="{ name: 'userAuditPeriods' }"
          exact
        >
          <v-list-item-icon>
            <v-icon>mdi-archive-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.user.auditPeriods") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item color="secondary" v-if="currentUser.state === 'APPROVED'" link :to="{ name: 'bookings' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-cart-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.user.bookings") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item color="secondary" link :to="{ name: 'userProfile' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.user.profile") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item color="secondary" link :to="{ name: 'contact' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.contact") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-if="$auth.may(['audit:users'])">
        <v-divider></v-divider>

        <v-list nav dense>
          <v-list-item color="secondary" link :to="{ name: 'auditHome' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-home-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.audit.home") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item color="secondary" link :to="{ name: 'auditYear', params: { year: currentYear } }">
            <v-list-item-icon>
              <v-icon>mdi-text-box-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.audit.currentYear") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item color="secondary" link :to="{ name: 'auditYears' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-archive-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.audit.years") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item color="secondary" link :to="{ name: 'auditOptions' }" exact v-if="$auth.may(['audit:finish'])">
            <v-list-item-icon>
              <v-icon>mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.audit.options") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-if="$auth.may(['admin:users'])">
        <v-divider></v-divider>

        <v-list nav dense>
          <v-list-item color="secondary" link :to="{ name: 'adminUsers' }">
            <v-list-item-icon>
              <v-icon>mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.admin.users") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item color="secondary" link :to="{ name: 'adminOffers' }">
            <v-list-item-icon>
              <v-icon>mdi-inbox-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.admin.offers") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item color="secondary" link :to="{ name: 'adminBookingsYears' }">
            <v-list-item-icon>
              <v-icon>mdi-account-cash-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.admin.bookings") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template #append>
        <v-list nav dense>
          <LanguageSwitch />
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.user.logout") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import LanguageSwitch from "@/components/LanguageSwitch";
import CurrentUserQuery from "@/gql/queries/CurrentUserQuery.gql";

export default {
  components: {
    LanguageSwitch,
  },

  data: () => ({
    drawer: null,
    currentUser: null,
  }),

  apollo: {
    currentUser: {
      query: CurrentUserQuery,
      result({ data }) {
        this.$i18n.locale = data.currentUser.language;
        this.$vuetify.lang.current = this.$i18n.locale;
      },
    },
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },

  methods: {
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>
